
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '@environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getAccessToken();
  const apiBaseUrl = environment?.api_url ?? '';

  // Never attach portal Bearer tokens to direct S3/AWS uploads — they break the signature.
  const isS3Request =
    req.url.includes('s3.amazonaws.com') ||
    req.url.includes('amazonaws.com') ||
    req.url.includes('.s3.');
  const isApiRequest = !!apiBaseUrl && req.url.startsWith(apiBaseUrl) && !isS3Request;

  // If we have a token, clone the request and add the header
  // Only send portal auth tokens to the customer-management API.
  if (token && isApiRequest) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(cloned);
  }

  // If no token, pass request as is
  return next(req);
};
